<template>
	<section class="page-dictionary">
		<header-page
			actions
			name="account-dictionary"
			:title="title"
			@run-action="runAction"
		/>
		<backButtonRoute/>
		<v-tabs
			align-with-title
			color="transparent"
			right
			slider-color="#33cfc7"
			class="px-4"
			v-model="activeTab">
			<v-tab
			v-for="(item, index) in tabs"
			:key="index"
			>
				{{ item.name }}
			</v-tab>
			<v-tabs-items v-model="activeTab">
				<v-card class="mt-3 mb-5">
					<dictionary-list
						:current-page="params.page"
						:last-page="table.lastPage"
						:rows="rows"
						@click-icon="clickIcon"
						@on-page="onPage"
						@on-search="onSearch"
					>
					</dictionary-list>
				</v-card>
			</v-tabs-items>
		</v-tabs>
		<section class="modal-filter-footer">
			<modal-sidebar-button
			hidden
			success-color="primary"
			success-text="Atras"
			@accept-button-clicked="returnDictionary"
			></modal-sidebar-button>
		</section>
		<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<action-sidebar
			:title="action.title"
			:value="action.visible"
			@close-modal="closeModal"
		>
			<dictionary-form
				v-if="isDictionaryForm"
				:id="selectedRow.id"
				:data-type="dataType"
				:subsidiary-module-id="moduleId"
				@close-modal="closeModal"
			/>
			<dictionary-form-remove
				v-if="isDictionaryRemove"
				:id="selectedRow.id"
				:name="selectedRow.name"
				@close-modal="closeModal"
			/>
		</action-sidebar>
	</section>
</template>

<script>

import {
	ACCOUNTING_DICTIONARY_FORM,
	ACCOUNTING_DICTIONARY_REMOVE,
	ACCOUNTING_DICTIONARY_NEW,
} from '@/shared/action-codes';
import actionBar from '@/components/shared/action-bar/action-bar';
import actionSidebar from '@/components/shared/action-sidebar';
import backButtonRoute from '@/components/shared/back-button-route';
import dictionaryList from '@/components/dictionary/dictionary-list';
import dictionaryForm from '@/components/dictionary/dictionary-form';
import dictionaryFormRemove from '@/components/dictionary/dictionary-form-remove';
import appButton from '@/components/shared/app-button';

function data() {
	return {
		action: {
			code: '',
			title: '',
			visible: false,
		},
		activeTab: 0,
		rows: [],
		limit: 50,
		selectedRow: {
			id: null,
		},
		tabs: [
			{ id: 1, name: 'Cabecera', disabled: false },
			{ id: 2, name: 'Detalle', disabled: false },
		],
	};
}

async function loadData() {
	this.$set(this.params, 'moduleId', this.moduleId);
	this.$set(this.params, 'dataType', this.dataType);
	this.$set(this.params, 'limit', this.limit);
	const { records } = await this.loadData('data-dictionary');
	this.rows = records.map(({ id, code, description, example, name, subsidiaryModuleId }) =>
		({ code, description, example, name, id, subsidiaryModuleId }),
	);
	return this.rows;
}

function clickIcon({ action, row }) {
	this.selectedRow.subsidiaryModuleId = row.subsidiaryModuleId;
	this.selectedRow.id = row.id;
	this.selectedRow.name = row.name;
	if (action === 'edit') {
		this.action.title = `Editar - ${row.name}`;
		this.action.code = ACCOUNTING_DICTIONARY_FORM;
	} else if (action === 'delete') {
		this.action.code = ACCOUNTING_DICTIONARY_REMOVE;
		this.action.title = `Eliminar - ${row.name}`;
	}
	this.action.visible = true;
}

function closeModal(reloadList) {
	this.action.code = '';
	this.action.title = '';
	this.action.visible = false;
	this.selectedRow.id = 0;
	if (reloadList) {
		loadData.call(this);
	}
}

async function created() {
	await loadData.call(this);
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function dataType() {
	return this.activeTab + 1;
}

function isDictionaryForm() {
	return this.action.code === ACCOUNTING_DICTIONARY_FORM
		|| this.action.code === ACCOUNTING_DICTIONARY_NEW;
}

function isDictionaryRemove() {
	return this.action.code === ACCOUNTING_DICTIONARY_REMOVE;
}

function moduleId() {
	return Number(this.$route.query.id);
}

async function onPage(page) {
	this.params.page = page;
	await loadData.call(this);
}

async function onSearch(value) {
	this.params.page = 1;
	this.$set(this.params, 'search', value || null);
	await loadData.call(this);
}

function runAction({ name, code }) {
	this.action.title = name;
	this.action.code = code;
	this.action.visible = true;
	this.selectedRow.id = 0;
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}

function title() {
	return `${this.$route.query.name} / ${this.$route.meta.title}`;
}

async function watchActiveTab() {
	this.params.page = 1;
	await loadData.call(this);
}

function returnDictionary() {
	this.$router.go(-1);
}

export default {
	name: 'page-dictionary',
	created,
	components: {
		actionBar,
		actionSidebar,
		appButton,
		dictionaryForm,
		dictionaryList,
		dictionaryFormRemove,
		backButtonRoute,
	},
	computed: {
		customerId,
		dataType,
		isDictionaryForm,
		isDictionaryRemove,
		moduleId,
		subsidiaryId,
		title,
	},
	data,
	methods: {
		clickIcon,
		closeModal,
		onPage,
		onSearch,
		returnDictionary,
		runAction,
	},
	watch: {
		activeTab: watchActiveTab,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/dictionary/page-dictionary.vue